module.exports = __webpack_public_path__ + "static/media/top-clouds@2x.45588a41.png";